/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import PropTypes from 'prop-types';
import { ButtonSecondary } from '@americanexpress/dls-react';
import { useEnhancedDataTableContext } from '../EnhancedDataTableContext';

const EnhancedTableToolbarButton = React.memo(() => {
  const context = useEnhancedDataTableContext();
  const {
    tableNm,
    toolbarBtnLabel,
    onToolbarBtnClick,
    toolbarButtonIcon,
    toolbarButtonComponent,
  } = context;

  if (toolbarButtonComponent) {
    return toolbarButtonComponent;
  }

  return toolbarBtnLabel && onToolbarBtnClick ? (
    <ButtonSecondary
      id={`${tableNm}-table-toolbar-button-component`}
      type="button"
      icon={toolbarButtonIcon ? toolbarButtonIcon : null }
      className="margin-responsive-r"
      onClick={onToolbarBtnClick}
    >
      {toolbarBtnLabel}
    </ButtonSecondary>
  ) : (<></>);
});

EnhancedTableToolbarButton.displayName = 'EnhancedTableToolbarButton';

EnhancedTableToolbarButton.propTypes = {
  onItemActionClick: PropTypes.func.isRequired,
};

export default EnhancedTableToolbarButton;
